import { hash } from '@ember/helper';
import { service } from '@ember/service';

import Component from 'umg-ember-backend/components/record-detail/forms';
import AssetPreview from 'umg-ember-backend/components/ui/asset-preview/index';
import Form from 'umg-ember-backend/components/ui/form';

export default class RecordDetailFormsExternalReferenceComponent extends Component {
  // Services
  @service data;

  // Template
  <template>
    <Form @model={{@model}} @showErrors={{@showErrors}} as |form|>
      <div class='o-layout'>
        <div class='o-layout__item u-1/1 u-1/2@tablet'>
          <form.fieldset @titleKey='general' as |fieldset|>
            <fieldset.field @property='val' />
            <fieldset.field @property='param' />

            <fieldset.field
              @property='type'
              @type='select-record'
              @options={{this.data.externalReferenceServices}}
            />

            <fieldset.field
              @property='artist'
              @type='belongs-to'
              @on={{hash openNewRecord=false openRecord=false}}
            />

            <fieldset.field
              @property='asset'
              @type='belongs-to'
              @on={{hash openNewRecord=false openRecord=false}}
              as |record|
            >
              <AssetPreview @asset={{record}} />
            </fieldset.field>
          </form.fieldset>
        </div>
      </div>
    </Form>
  </template>
}
